exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uJJfgYZXT0FPnRFk3atA0{font-weight:400;top:50px}html[dir] .uJJfgYZXT0FPnRFk3atA0 .ms-Panel-contentInner{padding-top:15px}._1O-XIEGLQRiiphCYvbG1uM{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:calc(100vh - 180px);overflow:hidden}._2NUTalNBxmQNuR6jlN3okI{overflow:auto}._2NUTalNBxmQNuR6jlN3okI,._3DiZB6adHRHuWPT6GzEvLT{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}html[dir] ._3DiZB6adHRHuWPT6GzEvLT{margin:0 15px}", ""]);

// exports
exports.locals = {
	"main": "uJJfgYZXT0FPnRFk3atA0",
	"container": "_1O-XIEGLQRiiphCYvbG1uM",
	"table": "_2NUTalNBxmQNuR6jlN3okI",
	"details": "_3DiZB6adHRHuWPT6GzEvLT"
};